<template lang="pug">
  .auth-group-item
    .top
      .title {{it.strategyName}}
      .opearte
        el-button(type="text" @click="$emit('edit',it)" ) 编辑
        el-button(type="text" @click="$emit('copy',it)" ) 复制
        el-button(type="text" @click="$emit('delete',it)" ) 删除
    .content
      el-form(label-position="left" label-width="120px" size="small")
        el-form-item(label="描述：")
          div {{it.remark}}
        el-form-item(label="权限组成员：")
          div.mt.tag-block(v-for="sub in it.subjects" )
            .name {{sub.subjectName}}：
            .tag-con
              el-tag.tag(v-for="v in sub.subjectValues" size="mini" ) {{v.value}}
        el-form-item(label="数据范围：" )
          div {{it.filters !== 'null' ?  it.filters : '自定义SQL'}}
        el-form-item(label="操作权限：" )
          div {{it.actions}}
</template>

<script>
export default {
  name: "",
  props: {
    it: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {};
  },
  computed: {},
  watch: {},
  created() {},
  methods: {}
};
</script>

<style scoped lang="scss">
.auth-group-item {
  padding: 16px;
  border-bottom: 1px solid #ddd;

  .top {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .flex {
    display: flex;
    align-items: flex-start;
  }

  .title {
    color: #333;
    font-size: 16px;
  }

  .content {
    ::v-deep {
      .el-form-item {
        margin-bottom: 0;
      }
    }

    .mt {
      margin-top: 12px;
    }
    .tag-block {
      line-height: 1.2;
      display: flex;
      justify-content: flex-start;

      .name {
        width: 80px;
        flex-shrink: 0;
        height: 32px;
        line-height: 20px;
      }

      .tag {
        margin-right: 12px;
        margin-bottom: 12px;
      }
    }
  }
}
</style>
